import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle } from "react-icons/fa";
import { RouteName } from "constant/routeNames";
import { Helmet } from "react-helmet-async";

function SubscriptionCancelPage() {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate(RouteName.SubscriptionPlan);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <>
      <Helmet>
        <title>Payment Cancelled - AYOZAT</title>
        <meta
          name="description"
          content="Your subscription payment was cancelled. You can try again anytime."
        />
        <meta property="og:title" content="Payment Cancelled - AYOZAT" />
        <meta
          property="og:description"
          content="Your subscription payment was cancelled."
        />
        <meta property="og:image" content="https://ayozat.co.uk/logo192.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Payment Cancelled - AYOZAT" />
        <meta
          name="twitter:description"
          content="Your subscription payment was cancelled."
        />
        <meta
          name="twitter:image"
          content="https://ayozat.co.uk/logo192.png"
        />
        <meta name="twitter:site" content="AYOZAT" />
      </Helmet>

      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-[80%] max-lg:w-[95%] max-sm:w-full bg-gray-900 rounded-2xl p-10 max-sm:p-6">
          {/* Cancel Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center">
              <FaTimesCircle className="text-red-500 text-4xl" />
            </div>
          </div>

          {/* Cancel Message */}
          <div className="text-center mb-8">
            <h1 className="text-[32px] max-lg:text-[25px] font-bold text-white mb-3 max-sm:text-[22px]">
              Payment Cancelled
            </h1>
            <p className="text-gray-400 text-[15px] max-w-md mx-auto">
              Your subscription payment was not completed. Don't worry — you can
              try again anytime. No charges have been made to your account.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-center gap-4 max-sm:flex-col">
            <button
              className="px-6 py-3 font-semibold text-center text-white rounded-full button-red max-sm:w-full"
              onClick={handleTryAgain}
            >
              Try Again
            </button>
            <button
              className="px-6 py-3 font-semibold text-center text-gray-300 rounded-full border border-gray-600 hover:border-gray-400 transition-colors max-sm:w-full"
              onClick={handleGoHome}
            >
              Go Home
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionCancelPage;
